import type { CompanyImage } from '@modules/professional/type/company-images';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import React from 'react';
import { CompanyImagesMobile } from '@modules/professional/component/about-tab/company-images/CompanyImages.mobile';
import { CompanyImagesDesktop } from '@modules/professional/component/about-tab/company-images/CompanyImages.desktop';

export interface CompanyImagesProps {
    imagePlacement: CompanyImage[];
    countRemaining: number;
    isLastImageLandscape: boolean;
    companyImages: CompanyImage[];
    isPortraitOnly: boolean;
    disablePhotoViewer?: boolean;
}

export const CompanyImages: React.FC<CompanyImagesProps> = (props) => {
    const { mobile } = useAppDisplayModeContext();

    if (mobile) {
        return <CompanyImagesMobile {...props} />;
    }
    return <CompanyImagesDesktop {...props} />;
};
